import { viewport } from '../../assets/js/functions'

(function ($) {

  var initializeBlock = function ($block) {
    $block.find('.loopingVideo video, .ivwc-media .lottieAnimation').each(function (index, val) {
      var inview = new Waypoint.Inview({
        element: $(this),
        enter: function (direction) {

        },
        entered: function (direction) {
          var $target = $(this.element[0])
          $target[0].play()
        },
        exit: function (direction) {

        },
        exited: function (direction) {
          var $target = $(this.element[0])
          $target[0].currentTime = 0
        }
      })
    });

    fixContentHeight($block);
    stickyBlocksPositioning($block);
    displayStickyBlock($block);

    $(window).on('load resize', function () {
      fixContentHeight($block);
      stickyBlocksPositioning($block);
    });

    $(window).on('scroll', function () {
      displayStickyBlock($block);
    });
  }

  window.initializeBlock = initializeBlock;

  var fixContentHeight = function ($block) {
    var $stickyBlocks = $block.find('.customGrid > .stickyParent > .ivwc-media .mediaContainer');
    var $sections = $block.find('.customGrid > .ivwc-content .ivwc-content');

    $stickyBlocks.closest('.ivwc-media').css({ padding: 0 });
    $sections.css({ padding: 0 });

    if (viewport().width <= 1024) return;

    $sections.each(function (i) {
      if (i !== 0 && i !== $sections.length - 1) return;

      var $stickyBlock = $stickyBlocks.eq(i);
      if (!$stickyBlock) return;

      var stickyBlockHeight = $stickyBlock.outerHeight();
      var sectionHeight = $(this).outerHeight();

      if (sectionHeight > stickyBlockHeight) {
        if (i === 0) {
          $stickyBlock.closest('.ivwc-media').css({ paddingTop: (sectionHeight - stickyBlockHeight) / 2 });
        } else {
          $stickyBlock.closest('.ivwc-media').css({ paddingBottom: (sectionHeight - stickyBlockHeight) / 2 });
        }
      } else {
        if (i === 0) {
          $(this).css({ paddingTop: (stickyBlockHeight - sectionHeight) / 2 });
        } else {
          $(this).css({ paddingBottom: (stickyBlockHeight - sectionHeight) / 2 });
        }
      }
    });
  }

  var displayStickyBlock = function ($block) {
    var $stickyBlockParents = $block.find('.customGrid > .stickyParent > .ivwc-media');
    var $sections = $block.find('.customGrid > .ivwc-content .ivwc-content');
    var windowHeight = $(window).height();
    var scrollTop = $(window).scrollTop();
    var currentIndex = 0;

    $sections.each(function (index) {
      var sectionOffset = $(this).offset().top - 100;
      var sectionHeight = $(this).outerHeight();
      var middleOfScreen = scrollTop + windowHeight / 2;

      if (middleOfScreen <= sectionOffset)
        return false;

      currentIndex = index;
    });

    $stickyBlockParents.each(function (i) {
      if (i === currentIndex) {
        $(this).addClass('show');
      } else {
        $(this).removeClass('show');
      }
    });
  }

  var stickyBlocksPositioning = function ($block) {
    var $stickyBlocks = $block.find('.customGrid > .stickyParent > .ivwc-media .mediaContainer');
    if (!$stickyBlocks.length) return;
    var windowHeight = $(window).height();

    $stickyBlocks.each(function () {
      var $stickyBlock = $(this);
      var stickyHeight = $stickyBlock.outerHeight();

      $stickyBlock.css({
        'top': `${windowHeight / 2 - stickyHeight / 2}px`,
      });
    });
  }

  window.addEventListener("load", function () {
    jQuery('.block--content-with-scrolling-media').each(function () {
      initializeBlock(jQuery(this));
    });
  });

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=content-with-scrolling-media', initializeBlock);
  }

})(jQuery);